import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import "./Awards.scss";
import CodeOff from "../../assets/images/awards-page/Hackathon (1).png";
import ApScript from "../../assets/images/awards-page/Hackathon.png";
import Gcloud from "../../assets/images/awards-page/goo-cloud.png";
import Hack2Connect from "../../assets/images/awards-page/Screenshot (113).png";
import GSol from "../../assets/images/awards-page/goo-sol.png";
import Covihacks from "../../assets/images/awards-page/JCRL-74FQ-A3UL-CBFA.png";
import Cicada from "../../assets/images/awards-page/Screenshot (114).png";

function Awards() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    useEffect(() => {
        const autoplayInterval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % awardsData.length);
        }, 4000);

        return () => clearInterval(autoplayInterval);
    }, []);

    const awardsData = [
        {
            id: 1,
            image: Gcloud,
            alt: "Google Cloud",
            title: "Google Cloud Program",
            description: "One of the top performers in Google Cloud program",
            achievement: "Top Performer"
        },
        {
            id: 2,
            image: Hack2Connect,
            alt: "Hack2Connect",
            title: "Hack-2-Connect 3.0",
            description: "Winner of the Hack-2-Connect 3.0 Hackathon",
            achievement: "Winner"
        },
        {
            id: 3,
            image: Covihacks,
            alt: "Covihacks",
            title: "Covihacks Hackathon",
            description: "Was in top 15 teams out of 150+ teams",
            achievement: "Top 15"
        },
        {
            id: 4,
            image: ApScript,
            alt: "ApScript",
            title: "ApScript Hackathon",
            description: "Finalist of the ApScript Hackathon",
            achievement: "Finalist"
        },
        {
            id: 5,
            image: GSol,
            alt: "Google Solution Challenge",
            title: "Google Solution Challenge",
            description: "Created a solution for one of the largest challenges by Google",
            achievement: "Solution Creator"
        },
        {
            id: 6,
            image: CodeOff,
            alt: "Code Off Duty",
            title: "Code Off Duty",
            description: "Was in the top 30 teams out of 200+ teams",
            achievement: "Top 30"
        },
        {
            id: 7,
            image: Cicada,
            alt: "Cicada 3301",
            title: "Cicada 3301",
            description: "Participant and created solution for the hack and was well appreciated",
            achievement: "Participant"
        }
    ];

    const handleDotClick = (index) => {
        setCurrentIndex(index);
    };

    return (
        <Container fluid className="awards-section" id="awards">
            <Container>
                <Row>
                    <Col xs={12}>
                        <div className="section-header text-center">
                            <h2 className="section-title">Awards & Achievements</h2>
                            <p className="section-subtitle">Recognition for my contributions and innovations</p>
                        </div>
                    </Col>
                </Row>
                
                <Row>
                    <Col xs={12}>
                        <div className="awards-carousel-container">
                            <div className="awards-carousel">
                                <div className="awards-container">
                                    {awardsData.map((award, index) => (
                                        <Card 
                                            key={award.id}
                                            className={`award-card ${index === currentIndex ? 'active' : ''} ${isVisible ? 'fade-in' : ''}`}
                                            style={{ animationDelay: `${index * 0.1}s` }}
                                        >
                                            <div className="award-image-container">
                                                <img 
                                                    className="award-image" 
                                                    alt={award.alt} 
                                                    src={award.image} 
                                                />
                                                <div className="achievement-badge">
                                                    <span>{award.achievement}</span>
                                                </div>
                                            </div>
                                            <Card.Body className="award-content">
                                                <h3 className="award-title">{award.title}</h3>
                                                <p className="award-description">{award.description}</p>
                                            </Card.Body>
                                        </Card>
                                    ))}
                                </div>
                                
                                <div className="carousel-dots">
                                    {awardsData.map((_, index) => (
                                        <button
                                            key={index}
                                            className={`dot ${index === currentIndex ? 'active' : ''}`}
                                            onClick={() => handleDotClick(index)}
                                            aria-label={`Go to award ${index + 1}`}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Container>
    );
}

export default Awards;
